<template>
    <div class="server_components">
        <label style="color:rgba(0, 0, 0, 0.85)" v-if="label">{{label}}：</label>
        <div class="server_container">
            <div class="server_select" :class="{'focus':focus}" @click="focus=!focus">
                <span v-if="!single">
                    <span v-if="selected.length>0">{{$t("common.selected")}}{{selected.length}}{{$i18n.locale == "zh_CN" ? "组服务器" : ""}}</span>
                    <span v-if="selected.length<=0" class="placeholder">{{placeholder?placeholder: $t("pageHeader.serverPlaceholder")}}</span>
                </span>
                <span v-if="single">
                    <span v-if="radio!=null && single_selected">{{single_selected.name}}</span>
                    <span v-if="radio==null" class="placeholder">{{placeholder?placeholder: $t("pageHeader.serverPlaceholder")}}</span>
                </span>
                <div class="server_select_clear" v-if="radio || selected.length>0" @click="clear()">
                    <a-icon type="close-circle" theme="filled"/>
                </div>
                <div class="server_select_arrow">
                    <a-icon type="down" />
                </div>
            </div>
            <div class="server_content" v-show="focus" :class="{'left':pos=='left'}">
                <div class="server_type">
                    <span :class="{'selected':type=='server'}" @click="type='server'">{{$t("pageHeader.serverList")}}</span>
                    <span :class="{'selected':type=='hefu'}" @click="type='hefu'">{{$t("pageHeader.crossServerList")}}</span>
                </div>
                <div v-if="type=='server'">
                    <a-row class="server_row">
                        <a-col span="8" class="server_region">{{$t("pageHeader.area")}}</a-col><a-col span="16">{{$t("pageHeader.server")}}</a-col>
                    </a-row>
                    <div class="server_list">
                        <a-row v-for="(region_servers, region) in onlines" :key="region" class="server_row">
                            <a-col span="8" class="server_region">
                                <a-checkbox v-if="!single" @change="onChangeRegion($event, region)" :checked="$_.filter(region_servers, {checked: false}).length <= 0" :indeterminate="$_.filter(region_servers, {checked: true}).length>0 && $_.filter(region_servers, {checked: false}).length>0">{{region}}</a-checkbox>
                                <span v-if="single">{{region}}</span>
                            </a-col>
                            <a-col span="16">
                                <a-row v-for="server in region_servers" :key="server.id" class="server_server">
                                    <a-checkbox v-if="!single" @change="onChangeServer($event, region)" :value="server.id" :checked="server.checked">{{server.id}}-{{server.name}}{{server.date?` (${server.date})`:''}}</a-checkbox>
                                    <a-radio :checked="radio==server.id" v-if="single" @click="onSelectServer(server.id)">{{server.id}}-{{server.name}}{{server.date?` (${server.date})`:''}}</a-radio>
                                </a-row>
                            </a-col>
                        </a-row>
                    </div>
                </div>
                <div v-if="type=='hefu'">
                    <div class="server_list">
                        <a-row v-for="server in servers['hefu']" :key="server.id" class="server_row">
                            <a-checkbox v-if="!single" @change="onChangeHefu($event, region)" :value="server.id" :checked="server.checked">{{server.id}}-{{server.name}}</a-checkbox>
                            <a-radio :checked="radio==server.id" v-if="single" @click="onSelectServer(server.id)">{{server.id}}-{{server.name}}</a-radio>
                        </a-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Radio, Checkbox} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Radio)
Vue.use(Checkbox)
// this.$i18n.locale
export default {
    props:['placeholder', 'label', 'value', 'single', 'pos'],
    created() {
        var self = this;
        document.addEventListener('click',function(e){
            let flag = false, clear = false;
            (e.path || (e.composedPath && e.composedPath())).forEach((i)=>{
                if(i.className == 'server_select_clear') {
                    clear = true
                }
                if(i.className == 'server_container') {
                    flag = true
                }
            })
            if(!flag || clear)
                self.focus = false
        })
        this.servers = _.cloneDeep(this.$store.state.game.servers)
        if(!this.servers) {
            this.servers = {}
        }
        if(!this.servers['online'])
            this.servers['online'] = []
        if(!this.servers['hefu'])
            this.servers['hefu'] = []
    },
    watch: {
        origin_servers(newV) {
            this.servers = _.cloneDeep(newV)
        },
        value(newV, oldV) {
            this.initVal(newV)
        },
    },
    mounted() {
        this.initVal(this.value)
    },
    computed: {
        origin_servers() {
            return this.$store.state.game.servers
        },
        single_selected() {
            let selected = _.find(this.servers["online"], {id:this.radio})
            if(!selected) {
                selected = _.find(this.servers["hefu"], {id:this.radio})
            }
            if(this.single==true) {
                if((selected?selected.id:null) != this.value) {
                    if(this.radio!=this.value) {
                        this.$emit("change")
                        this.$emit("input", selected?selected.id:null)
                    }
                }
            }
            return selected
        },
        selected() {
            let selected = _.concat(_.filter(this.servers["online"], {checked:true}), _.filter(this.servers["hefu"], {checked:true}))
            if(this.single!=true && this.init!==false) {
                let ids = _.map(selected, 'id')
                if(_.difference(ids, this.value).length>0 || _.difference(this.value, ids).length>0) {
                    this.$emit("change")
                    this.$emit("input", ids)
                }
            }
            this.init = true
            return selected
        },
        onlines() {
            return _.groupBy(this.servers["online"], 'region')
        },
    },
    methods: {
        initVal(newV) {
            if(this.single) {
                let selected = _.find(this.servers["online"], {id:newV})
                if(!selected) {
                    selected = _.find(this.servers["hefu"], {id:newV})
                }
                if(selected) {
                    this.radio = newV
                }
                else {
                    this.radio = null
                    this.$emit("input", null)
                }
            }
            else {
                let val = newV?newV instanceof Array?newV:[]:[]
                let flag = false
                this.servers['online'].forEach((server)=>{
                    if(val.indexOf(server.id)>-1) {
                        server.checked = true
                        flag = true
                    } else {
                        server.checked = false
                    }
                })
                
                this.servers['hefu'].forEach((server)=> {
                    if(val.indexOf(server.id)>-1) {
                        server.checked = true
                        flag = true
                    } else {
                        server.checked = false
                    }
                })
                if(flag === false && val.length>0) {
                    this.$emit("input", [])
                }
            }
        },
        onSelectServer(id) {
            this.radio = id
            this.focus = false
        },
        onChangeServer(e, region ) {
            let server = _.find(this.servers["online"], {id:e.target.value})
            server.checked = e.target.checked
        },
        onChangeHefu(e) {
            let server = _.find(this.servers["hefu"], {id:e.target.value})
            server.checked = e.target.checked
        },
        onChangeRegion(e, region ) {
            _.map(this.servers["online"], (s)=>{if(s.region===region) s.checked=e.target.checked})
        },
        closeServer(id) {
            let server = _.find(this.servers["online"], {id:id})
            if(!server) {
                server = _.find(this.servers["hefu"], {id:id})
            }
            if(server) {
                server.checked = false
            }
        },
        clear() {
            if(this.single) {
                this.radio = null
            }
            else {
                this.servers['online'].forEach((server)=>{
                    server.checked = false
                })
                
                this.servers['hefu'].forEach((server)=> {
                    server.checked = false
                })
            }
            this.$emit("change")
            this.$emit("input", null)
        },
    },
    data() {
        return {
            init: false,
            focus: false,
            type: 'server',
            radio: null,
            servers: {
                'online': [],
                'hefu': [],
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../assets/less/var.less';
::-webkit-scrollbar  
{  
    width: 8px;  /*滚动条宽度*/
    height: 8px;  /*滚动条高度*/
} 

/*定义滑块 内阴影+圆角*/  
::-webkit-scrollbar-thumb  
{  
    border-radius: 10px;  /*滚动条的圆角*/
    background-color: #d8d8d8;  /*滚动条的背景颜色*/
}  

.server_components {
}
.server_container {
    position:relative;
    display: inline-block;
    text-align: left;

    .server_select {
        position: relative;
        display: inline-block;
        padding: 4px 11px;
        width: 210px;
        height: 32px;
        font-size: 14px;
        line-height: 1.5;
        color: rgba(0, 0, 0, 0.65);
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        cursor: pointer;
        touch-action: manipulation;

        .placeholder {
            color: #bbb;
        }
        .server_select_clear {
            position: absolute;
            right: 11px;
            display: inline-block;
            color: rgba(0, 0, 0, 0.45);
            display: none;
            z-index: 112;
        }
        &:hover .server_select_clear {
            display: inherit;
        }
        .server_select_arrow {
            display: inline-block;
            font-style: normal;
            vertical-align: -0.125em;
            text-align: center;
            text-transform: none;
            line-height: 0;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            position: absolute;
            top: 50%;
            right: 11px;
            line-height: 1;
            margin-top: -6px;
            -webkit-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
            color: rgba(0, 0, 0, 0.25);
            font-size: 12px;
            z-index:111;

            svg {
                transition: transform 0.3s;
                -webkit-transform: 0.3s;
            }
        }

        &:hover {
            border-color: #40a9ff;
            border-right-width: 1px !important;
        }
        &.focus {
            border-color: #40a9ff;
            border-right-width: 1px !important;
            -webkit-box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2); 
            box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);

            .server_select_arrow {
                svg {
                    transform: rotate(180deg)
                }
            }
        }
    }

    .server_content {
        position: absolute; 
        z-index: 1005;
        top: 55px; 
        right: 0px; 
        width:400px;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        background: #fff;
        border:1px solid #ddd;
        &.left{
            left:0;
        }
        .server_type {
            padding: 0 10px;
            border-bottom: 1px solid #ddd;
            line-height: 40px;
            span {
                margin:0 20px 0 0;
                padding: 2px 10px;
                cursor: pointer;
            }
            span.selected {
                background:#108ee9;
                color: #fff;
                border-radius: 4px;
            }
        }
        .server_list {
            height:300px;
            overflow: scroll;
            overflow-x:hidden
        }
        .server_row {
            padding: 0 10px;
            border-bottom: 1px solid #ddd;
            line-height: 30px;
        }
        .server_server {
            padding:0 0 0 10px;
            border-left: 1px solid #ddd;
            line-height: 30px;
            cursor: pointer;
            &:hover {
                background:@hover-color;
            }
        }
    }
}

.server_selected {
    .ant-divider {
        margin: 15px 0 5px 0;
    }
}
</style>